var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import { Avatar as AntdAvatar } from "@riseart/antd-provider";
import classnames from "classnames";
import { avatarCls, avatarAlignLeftCls, avatarThemeBlackCls, avatarImageCls, avatarLetterCls, avatarTextCls, avatarColor, avatarSizeSmallCls, avatarSizeMediumCls, avatarSizeLargeCls } from "./Avatar.less";
function Avatar(_ref) {
  var align = _ref.align, className = _ref.className, _ref$image = _ref.image, image = _ref$image === void 0 ? null : _ref$image, name = _ref.name, theme = _ref.theme, children = _ref.children, _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? null : _ref$alt, _ref$size = _ref.size, size = _ref$size === void 0 ? "large" : _ref$size, _ref$style = _ref.style, style = _ref$style === void 0 ? null : _ref$style;
  var SIZE_TO_PX = {
    small: 20,
    medium: 40,
    large: 80
  };
  var SIZE_TO_CLS = {
    small: avatarSizeSmallCls,
    medium: avatarSizeMediumCls,
    large: avatarSizeLargeCls
  };
  var antdSize = SIZE_TO_PX[size] || SIZE_TO_PX.medium;
  return /* @__PURE__ */ React.createElement("div", {
    className: classnames(avatarCls, _defineProperty({}, avatarAlignLeftCls, align === "left"), _defineProperty({}, avatarThemeBlackCls, theme === "black"), SIZE_TO_CLS[size], className)
  }, /* @__PURE__ */ React.createElement("div", {
    className: avatarImageCls
  }, image ? /* @__PURE__ */ React.createElement(AntdAvatar, _extends({
    style,
    size: antdSize,
    src: image
  }, alt ? {
    alt
  } : null)) : /* @__PURE__ */ React.createElement(AntdAvatar, _extends({
    size: antdSize,
    className: avatarLetterCls,
    style: _objectSpread({
      backgroundColor: avatarColor
    }, style)
  }, alt ? {
    alt
  } : null), name ? name.charAt(0) : null)), children && /* @__PURE__ */ React.createElement("p", {
    className: avatarTextCls
  }, children));
}
__name(Avatar, "Avatar");
export {
  Avatar
};
